export const SET_CONVERSATIONS = 'chat/SET_CONVERSATIONS'
export const UPDATE_CONVERSATION = 'chat/UPDATE_CONVERSATION'
export const RESET_CHAT = 'chat/RESET_CHAT'
